const getCaretY = (textarea) => {
  if (!textarea) return null;

  const computed = getComputedStyle(textarea);
  const text = textarea.value.slice(0, textarea.selectionStart);

  const div = document.createElement("div");
  document.body.prepend(div);
  const width =
    textarea.clientWidth +
    Number(computed.borderWidth.replace("px", "") * 2 || 0);

  Object.assign(div.style, {
    position: "absolute",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    visibility: "hidden",
    font: computed.font,
    lineHeight: computed.lineHeight,
    padding: computed.padding,
    border: computed.border,
    boxSizing: computed.boxSizing,
    width: `${width}px`,
  });

  const textSpan = document.createElement("span");
  div.appendChild(textSpan);
  textSpan.textContent = text;

  const span = document.createElement("span");
  span.textContent = "\u200b"; // Zero-width space
  div.appendChild(span);

  const { top: spanTop } = span.getBoundingClientRect();

  document.body.removeChild(div);

  return spanTop + window.scrollY;
};

export default getCaretY;
